import { createSlice } from '@reduxjs/toolkit';
import {
  getMonitorRun,
  getMonitorRuns,
} from 'features/admin-monitoring/runs/async';
import { MonitoringRunsState } from 'features/admin-monitoring/runs/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: MonitoringRunsState = {
  list: { data: undefined, request: initialRequestState },
  detail: { data: undefined, request: initialRequestState },
};

const slice = createSlice({
  name: 'monitoringRuns',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getMonitorRuns.pending, (state, { meta }) => {
      state.list.request = requestReducer(
        state.list.request,
        pending({ meta })
      );
    });
    builder.addCase(getMonitorRuns.fulfilled, (state, { meta, payload }) => {
      if (state.list.request.id === meta.requestId) {
        state.list.data = payload;
        state.list.request = requestReducer(
          state.list.request,
          fulfilled({ meta })
        );
      }
    });
    builder.addCase(getMonitorRuns.rejected, (state, { meta }) => {
      state.list.request = requestReducer(
        state.list.request,
        rejected({ meta })
      );
    });

    builder.addCase(getMonitorRun.pending, (state, { meta }) => {
      state.detail.data = undefined;
      state.detail.request = requestReducer(
        state.detail.request,
        pending({ meta })
      );
    });
    builder.addCase(getMonitorRun.fulfilled, (state, { meta, payload }) => {
      if (state.detail.request.id === meta.requestId) {
        state.detail.data = payload;
        state.detail.request = requestReducer(
          state.detail.request,
          fulfilled({ meta })
        );
      }
    });
    builder.addCase(getMonitorRun.rejected, (state, { meta }) => {
      state.detail.request = requestReducer(
        state.detail.request,
        rejected({ meta })
      );
    });
  },
});

export const { reset } = slice.actions;

const { reducer } = slice;

export default reducer;
